import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
    Button,
    TableCell,
    TableRow,
} from "@material-ui/core";
import { enviarPDFCertificado, imprimirPDFCertificado } from "../../../../actions/certificadoAtencion/certificadoAtencionActions";
import { Mail, Print } from "@material-ui/icons";


const useRowStyles = makeStyles({
    root: {
        "& > *": {
            borderBottom: "unset",
        },
    },
});

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const CertificadoAtencionItem = (props) => {
    const dispatch = useDispatch();
    const { item } = props;
    const classes = useRowStyles();

    return (
        <>
            <TableRow className={classes.root} >
                <TableCell align="left">{new Date(item.fecha).toLocaleString("es", optionsfecha)} </TableCell>
                <TableCell align="left">{item.id}</TableCell>
                <TableCell align="left">{item.carnet}</TableCell>
                <TableCell align="left">{item.apellidoNombre}</TableCell>
                <TableCell align="left">{item.descripcionCentroMedico}</TableCell>
                <TableCell align="left">{item.descripcionEspecialidad}</TableCell>
                <TableCell align="left">{item.descripcionEfector}</TableCell>
                <TableCell>
                    <Button
                        style={{ fontSize: "0.8rem" }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            dispatch(enviarPDFCertificado(item.id, false, false))
                        }}
                    >
                        <Mail />    
                    </Button>
                </TableCell>
                <TableCell>
                    <Button
                        style={{ fontSize: "0.8rem" }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            dispatch(imprimirPDFCertificado(item.id, false, false))
                        }}
                    >
                       <Print />
                    </Button>
                </TableCell>
            </TableRow>
        </>
    );
};
